import _ from "lodash";

export default {
    methods: {
        attachUser(user) {
            if (user.email === '') {
                return
            }

            this.$http.put(`api/v1.0/projects/${this.$route.params.id}/attach_user/${user.id}`, {
                is_owner: user.is_owner,
                receive_letters: user.receive_letters,
            })
                .then((response) => {
                    this.$q.notify({
                        message: `Сохранено`,
                        type: 'info',
                        position: 'bottom'
                    });

                    this.$store.commit('project/setUsers', response.data)

                    const owner = response.data.find(user => user.is_owner)

                    this.$store.commit('project/setProjectOwner', owner)
                    this.$store.commit('project/setProjectOwnerId', owner.id)
                })
                .catch((error) => {
                    _.forIn(error.response.data.errors, (value, key) => {
                        this.$q.notify(value[0]);
                    })
                });
        },
    }
}


// WEBPACK FOOTER //
// ./resources/assets/js/mixins/projectUser/projectUser.js